import { signal } from '@preact/signals-core';
import type { Quality, Tier } from './event-bus';

export type LoadState = 'loading' | 'ready' | 'no-webgl' | 'error';
export type Phase = 'splash' | 'intro' | 'name' | 'play';
export type Sheet = 'none' | 'settings' | 'book' | 'share';
export type ShareTemplate = 'prayer' | 'fortune' | 'tamAn';

export interface ShareFocus {
  template: ShareTemplate;
  id?: string;
}

export interface ZoneAction {
  activityId: string;
  labelKey: string;
}

export interface ReadPrayer {
  text: string;
  kind: 'silk' | 'lantern';
  createdAt?: number;
}

export interface Toast {
  key: string;
  vars?: Record<string, string | number>;
  id: number;
}

export interface Approach {
  zoneId: string;
}

export function createStore() {
  return {
    loadState: signal<LoadState>('loading'),
    phase: signal<Phase>('splash'),
    playerName: signal(''),
    zoneId: signal<string | null>(null),
    zoneActions: signal<readonly ZoneAction[]>([]),
    activeActivity: signal<string | null>(null),
    approaching: signal<Approach | null>(null),
    readPrayer: signal<ReadPrayer | null>(null),
    muted: signal(false),
    tier: signal<Tier>('mid'),
    quality: signal<Quality>('auto'),
    visitorCount: signal(0),
    tutorialStep: signal(0),
    sheet: signal<Sheet>('none'),
    shareFocus: signal<ShareFocus | null>(null),
    toast: signal<Toast | null>(null),
    persistent: signal(true),
    touch: signal(false),
  };
}

export type Store = ReturnType<typeof createStore>;
